import React from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { showToast } from "../../common/toastNotification";
import { loginResponseData } from "../../../types/login";
import { loginDetails } from "../../../globalState/actions/authAction/authAction";
import { useDispatch } from "react-redux";
import loginService from "../../../services/loginServices";
import dashboardService from "../../../services/DashboardServices";
import { setFinancialYear } from "../../../globalState/actions/dashboard/dashboardAction";

const LoginCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const user = params.get("user");
    const token = params.get("token");
    if (status === "success" && token) {
      const tempUserDetails: loginResponseData = {
        email: user || "",
        username: user || "",
        authToken: token,
      };
      localStorage.setItem("token", token);
      fetchUserDetailsData(tempUserDetails);
    } else {
      showToast("Login failed", "error");
      navigate("/");
    }
  }, [location, navigate]);

  const fetchUserDetailsData = async (tempUserDetails: loginResponseData) => {
    // const payload = {
    //   EmailId: tempUserDetails.email,
    // };

    try {
      const response = await loginService.GetUserDetailsByEmailDataAPI();
      const finalResponse = response.data.data;
      if (finalResponse) {
        const finalUserResponse = {
          ...finalResponse,
          authToken: tempUserDetails.authToken,
        };

        dispatch(loginDetails(finalUserResponse));

        const financialYearResponse =
          await dashboardService.getFinancialYearAPI();
        const financialYearData = financialYearResponse.data?.data;

        if (financialYearData?.startDate && financialYearData?.endDate) {
          dispatch(
            setFinancialYear(
              financialYearData.startDate,
              financialYearData.endDate
            )
          );
        } else {
          const currentYear = new Date().getFullYear();
          const fallbackDates = {
            startDate: new Date(Date.UTC(currentYear, 3, 1)).toISOString(), // April 1
            endDate: new Date(Date.UTC(currentYear + 1, 2, 31)).toISOString(), // March 31
          };

          dispatch(
            setFinancialYear(fallbackDates.startDate, fallbackDates.endDate)
          );
        }
        localStorage.setItem("userDetails", JSON.stringify(finalUserResponse));
        const redirectUrl = localStorage.getItem("postLoginRedirect");
        if (redirectUrl) {
          localStorage.removeItem("postLoginRedirect");
          window.location.href = redirectUrl;
        } else {
          navigate("/dashboard");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return <div>Redirecting...</div>;
};

export default LoginCallback;
